var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.colorclass},[_c('label',[_vm._v(_vm._s(_vm.titleWithOverride))]),_c('label',{staticClass:"gianttext"},[_vm._v(_vm._s(_vm.count))]),_c('label',[_vm._v(_vm._s(_vm._f("toCurrency")(_vm.amount)))])])}
var staticRenderFns = []

export { render, staticRenderFns }